module.exports = __webpack_public_path__ + "assets/img/29_1135_big.a87f448e.jpg";